module.exports = __webpack_public_path__ + "img/zoomOut.21bdc075.svg";